module.exports = __webpack_public_path__ + "static/img/AllInOne8.fffabb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AllInOne8.png
// module id = oGxA
// module chunks = 2